import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { emptyToNull, namesConflict } from "@shared/helpers/volunteer-organization";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { VolunteerOrgProjectAssignment } from "../volunteer-org-project-assignment/entity";
import { VolunteerOrgProject } from "./entity";

export const VolunteerOrgProjectEntityConfig: HyperEntityConfig<VolunteerOrgProject> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    async saving(entity) {
      entity.name = entity.name?.trim() ?? "";
      if (!entity.name) {
        throw new Error("שם הפרויקט חובה");
      }
      entity.description = emptyToNull(entity.description);
      const others = await remult.repo(VolunteerOrgProject).find();
      if (
        others.some(
          (row) => row.id !== entity.id && namesConflict(row.name, entity.name),
        )
      ) {
        throw new Error("כבר קיים פרויקט בשם זה");
      }
    },
    async deleting(entity) {
      const count = await remult
        .repo(VolunteerOrgProjectAssignment)
        .count({ projectId: entity.id });
      if (count > 0) {
        throw new Error("לא ניתן למחוק פרויקט עם שיבוצים. ניתן לכבות אותו.");
      }
    },
  };
